const locale = {
	EXKURSIO: "Exkursio",
	OVERVIEW: "Overview",
	WELCOMEBACK: "Welcome back",
	TRIPS: "Trips",
	MYTRIPS: "My Trips",
	EMPLOYEETRIPS: "Employee Trips",
	VEHICLES: "Vehicles",
	MYVEHICLES: "My Vehicles",
	EMPLOYEEVEHICLES: "Employee Vehicles",
	REPORTS: "Reports",
	QUICKNAVIGATION: "Quick Navigation",
	LIVESTATS: "Live Statistics",
	ACTIVETRIPS: "Active Trips",
	AVAILABLEVEHICLES: "Available Vehicles",
	VEHICLE: "Vehicle",
	KMTHISMONTH: "km this month",
	FUELEFFICIENCY: "Fuel Efficiency",
	RECENTTRIPS: "Recent Trips",
	VEHICLESTATUS: "Vehicle Status",
	DRIVER: "Driver",
	FUEL: "Fuel",
	ACTIVE: "Active",
	COMPLETED: "Completed",
	SCHEDULED: "Scheduled",
	AVAILABLE: "Available",
	MAINTENANCE: "Maintenance",
	INACTIVE: "Inactive",
	ARCHIVED: "Archived",
	SEARCH: "Search",
	VEHICLESNOTAVAILABLE: "Vehicles not available",
	NOVEHICLESFOUND: "No vehicles found",
	GOTOVEHICLES: "Go to Vehicles",
	NODATAFOUND: "No data found",
	VIEWING_VEHICLES_FOR: "Viewing vehicles for",
	CLOSE: "Close",
	ADDVEHICLE: "Add Vehicle",
	BACK: "Back",
	EDIT: "Edit",
	CAPACITY: "Capacity",
	PERSONCAPACITY: "Person Capacity",
	PERSONS: "Persons",
	TYPE: "Type",
	UNKNOWN: "Unknown",
	VEHICLENAME: "Vehicle Name",
	DESCRIPTION: "Description",
	LICENSEPLATE: "License Plate",
	VEHICLETYPE: "Vehicle Type",
	CAR: "Car",
	SUV: "SUV",
	TRUCK: "Truck",
	VAN: "Van",
	BUS: "Bus",
	MINIBUS: "Minibus",
	MOTORCYCLE: "Motorcycle",
	PICKUP: "Pickup Truck",
	TRAILER: "Trailer",
	SEMITRAILER: "Semi-Trailer",
	CAMPER: "Camper/RV",
	CONVERTIBLE: "Convertible",
	COUPE: "Coupe",
	SEDAN: "Sedan",
	HATCHBACK: "Hatchback",
	WAGON: "Station Wagon",
	CROSSOVER: "Crossover",
	MINIVAN: "Minivan",
	YEAROFMANUFACTURE: "Year of Manufacture",
	CURRENTLOCATION: "Current Location",
	BRAND: "Brand",
	MODEL: "Model",
	YEAR: "Year",
	FUELTYPE: "Fuel Type",
	LICENSEDTO: "Licensed To",
	PS: "Horsepower (PS)",
	DIESEL: "Diesel",
	GASOLINE: "Gasoline",
	ELECTRIC: "Electric",
	HYBRID: "Hybrid",
	CNG: "CNG (Compressed Natural Gas)",
	LPG: "LPG (Liquefied Petroleum Gas)",
	HYDROGEN: "Hydrogen",
	BIODIESEL: "Biodiesel",
	ETHANOL: "Ethanol",
	PLUGINHYBRID: "Plug-in Hybrid",
	EDITVEHICLE: "Edit Vehicle",
	CREATENEWVEHICLE: "Create New Vehicle",
	ARCHIVEVEHICLE: "Archive Vehicle",
	CREATEDAT: "Created",
	CREATED: "Created",
	FROM: "from",
	ME: "me",
	SAVE: "Save",
	LOADING: "Loading",
	VEHICLESAVED: "Vehicle saved successfully",
	CREATENEWTRIP: "Create New Trip",
	EDITTRIP: "Edit Trip",
	TRIPNAME: "Trip Name",
	STARTDATE: "Start Date",
	ENDDATE: "End Date",
	STARTTIME: "Start Time",
	ENDTIME: "End Time",
	DESTINATION: "Destination",
	PARTICIPANTS: "Participants",
	STATUS: "Status",
	PENDING: "Pending",
	CONFIRMED: "Confirmed",
	CANCELLED: "Cancelled",
	DATE: "Date",
	TIME: "Time",
	ACTIONS: "Actions",
	NOTRIPSTHISPERIOD: "No trips found for this period",
	TRACK: "Track",
	KILOMETERS: "Kilometers",
	REASON: "Reason",
	STARTDATETIME: "Start Date & Time",
	ENDDATETIME: "End Date & Time",
	ATTENTION: "Attention",
	DELETETRIPQUESTION: "Do you really want to delete this trip?",
	YES: "Yes",
	NO: "No",
	DAY: "Day",
	WEEK: "Week",
	MONTH: "Month",
	TOTALTRIPS: "Total Trips",
	TOTALKM: "Total KM",
	STARTKM: "Start KM",
	ENDKM: "End KM",
	LASTTRIPENDKM: "Last Trip End KM",
	SEAL: "Seal",
	RANGE: "Range",
	SEALING: "Sealing",
	SEALED: "Sealed",
	ENTERREASONFORSEALING: "Enter reason for sealing this period...",
	SEALTRIP: "Seal Trip",
	SEALTRIPQUESTION: "Are you sure you want to seal this trip?",
	SELECTMONTH: "Select Month",
	SELECTDATE: "Select Date",
	CANCEL: "Cancel",
	COMMENT: "Comment",
	OPTIONALCOMMENT: "Optional comment...",
	REPORTTYPE: "Report Type",
	OBSERVATIONPERIOD: "Observation Period",
	SELECTREPORTTYPE: "Select Report Type",
	COMINGSOON: "Coming Soon",
	SELECTPERIOD: "Select Period",
	SELECTVEHICLES: "Select Vehicles",
	THISMONTH: "This Month",
	LASTMONTH: "Last Month",
	THISYEAR: "This Year",
	LASTYEAR: "Last Year",
	BACK: "Back",
	NEXT: "Next",
	EMPLOYEESWITHEXKURSIO: "Employees with Exkursio",
	PEOPLE: "People",
	NAME: "Name",
	USERNAME: "Username",
	DISPLAYNAME: "Display Name",
	TOTHETRIPS: "Go to Trips",
	LINKNOTVALIDFORUSER: "Link not valid for this user",
	GENERATEREPORT: "Generate Report",
	REPORTFOR: "Report for",
	CALCULATIONDATE: "Calculation Date",
	LOADINGREPORT: "Loading Report...",
	AVERAGEDISTANCE: "Average Distance",
	AVERAGEDURATION: "Average Duration",
	TRIPSBYREASON: "Time by Vehicles",
	VEHICLEPERFORMANCE: "Vehicle Performance",
	DAILYDISTANCE: "Daily Distance",
	DAILYSTATS: "Daily Statistics",
	DETAILEDBREAKDOWN: "Detailed Breakdown",
	TOTALDURATION: "Total Duration",
	AVERAGEKM: "Average KM",
	THISWEEK: "This Week",
	LASTWEEK: "Last Week",
	SELECTALL: "Select All",
	DESELECTALL: "Deselect All",
	CHOOSEVEHICLES: "Choose Vehicles",
	SHOWARCHIVEDVEHICLES: "Show Archived Vehicles",
	SELECTNOTHING: "Select Nothing",
	SELECTREPORTTYPE: "Select Report Type",
	SELECTPERIOD: "Select Period",
	STARTDATE: "Start Date",
	ENDDATE: "End Date",
	BACK: "Back",
	NEXT: "Next",
	EXPORT: "Export",
	TRIPCOUNT: "Trip Count",
	KILOMETERS: "Kilometers",
	DISTANCE: "Distance",
	DURATION: "Duration",
	DATE: "Date",
	VEHICLES: "Vehicles",
	COLOR: "Color",
	ICON: "Icon",
	TODAY: "Today",
	TOTALDISTANCE: "Total Distance",
	USEDVEHICLES: "Used Vehicles",
	TOTALTIME: "Total Time",
	DAYSSTATUS: "Days Status",
	UNSEALED: "Unsealed",
	UNSEALDATERANGEQUESTION: "Do you want to unseal this date range?",
	UNSEALTRIPQUESTION: "Do you want to unseal this trip?",
	EXPORTSELECTEDDATA: "Export selected data",
	EXPORTAS: "Export as",
	EXPORTTYPE: "Export type",
	SHORTSUMMARY: "Short summary",
	DAYTOTALOVERVIEW: "Per vehicle total view",
	SINGLELISTINGS: "Single listings",

	DATEANDTIMEFORMAT: "Date & time format",
	DATEANDTIMECOMBINED: "Date & time combined",
	DATEONLY: "Date only",
	TIMEONLY: "Time only",
	DURATIONSUMFORMAT: "Duration & sum format",
	HOURSMINUTESSECONDS: "Hours, minutes, seconds",
	HOURSMINUTES: "Hours, minutes",
	HOURS: "Hours",
	MINUTES: "Minutes",
	SECONDS: "Seconds",
	WITHSIGNATURE: "with signature field",
	SHOWCALCULATIONTIMESTAMP: "Show calculation timestamp",
	SHOWSEALEDREPORT: "Show sealed on report",
	SEALDATERANGE: "Seal date range on report export",
	SEALDATERANGECONFIRM: "Do you really want to seal the date range when exporting this report?",
	DATERANGEALREADYSEALED: "This date range is already sealed. The export will proceed without additional sealing.",
	SEALEDRANGES: "Existing sealed ranges",
	ALREADYSEALED: "already sealed",
	PARTIALLYSEALED: "partially sealed",
	EXPORTREPORT: "Export Report",
	STARTDATE: "Start Date",
	ENDDATE: "End Date",
	TRACK: "Track",
	STARTKM: "Start KM",
	ENDKM: "End KM",
	LICENSEPLATE: "License Plate",
	TOTALTRIPS: "Total Trips",
	STARTTIME: "Start Time",
	ENDTIME: "End Time",
	ROUTE: "Route",
	BRAND: "Brand",
	MODEL: "Model",
	VEHICLESTATISTICS: "Vehicle Statistics",
	DETAILEDTRIPS: "Detailed Trip Listing",
	UNIQUEVEHICLES: "Vehicles",
	ACCEPTANCE: "Acceptance",
	SIGNATURESUPERVISOR: "Supervisor",
	SIGNATUREEMPLOYEE: "Employee",
	SIGNATUREINFOTEXT: "I hereby confirm the accuracy of the above information.",
	ONLINE: "Online",
	AWAY: "Away",
	RECENTLY_ACTIVE: "Recently Active",
	OFFLINE: "Offline",
	UNKNOWN: "Unknown",
	NEVER: "Never",
	JUST_NOW: "Just now",
	MINUTES_AGO: "{{count}} minutes ago",
	MINUTES_AGO_plural: "{{count}} minutes ago",
	HOURS_AGO: "{{count}} hours ago",
	HOURS_AGO_plural: "{{count}} hours ago",
	DAYS_AGO: "{{count}} days ago",
	DAYS_AGO_plural: "{{count}} days ago",
	THIS_MONTH: "This Month",
	LAST_ONLINE: "Last Online",
	FOR: "for"
};

export default locale;
